export default {
  form: {
    should_save_payment_info: {
      label: 'Salva i dati di pagamento per un checkout più rapido',
    },
  },
};
